var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_svg2__a",
    x1: 12.24,
    x2: 198.24,
    y1: 179.86,
    y2: 21.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#edit_svg2__a",
    id: "edit_svg2__b",
    x1: 7.53,
    x2: 193.53,
    y1: 174.32,
    y2: 16.32
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M184.6 125.51h-.01c-2.75 0-4.98 2.24-4.98 5.01v44.45c0 8.29-6.69 15.01-14.94 15.02H24.91c-8.25 0-14.93-6.73-14.94-15.02V44.51c0-8.29 6.69-15.01 14.94-15.02h44.23c2.75 0 4.98-2.24 4.98-5.01s-2.23-5.01-4.98-5.01H24.91C11.16 19.5.02 30.69 0 44.51v130.46c.02 13.82 11.16 25.02 24.91 25.03h139.76c13.75-.02 24.89-11.21 24.91-25.03v-44.45c0-2.77-2.23-5.01-4.98-5.01",
    style: {
      fill: "url(#edit_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.44 12.46-5.84-5.87c-8.75-8.79-22.95-8.79-31.7 0L67.04 95.9a5 5 0 0 0-1.28 2.2l-11.69 42.4c-.48 1.74 0 3.6 1.28 4.88 1.27 1.28 3.12 1.77 4.85 1.28l42.19-11.75c.83-.23 1.58-.67 2.19-1.28l88.86-89.32c8.74-8.8 8.74-23.06 0-31.86ZM66.02 134.68l7.18-26.05 18.74 18.83zm35.33-11.94L77.9 99.17l72.72-73.1 23.46 23.57zm85.05-85.5-5.28 5.32-23.46-23.58 5.28-5.31a12.403 12.403 0 0 1 17.61 0l5.85 5.87c4.85 4.89 4.85 12.81 0 17.7",
    style: {
      fill: "url(#edit_svg2__b)"
    }
  }));
};
export default SvgEdit;